import React from 'react';

interface PageLayoutProps {
  show?: boolean;
  pageTitle?: string;
  children?: React.ReactNode;
  actionButton?: React.ReactNode;
  isHide?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  show = true,
  pageTitle,
  children,
  actionButton,
  isHide = false,
}) => {
  if (!show) return <>{children}</>;

  return (
    <div className="bg-[#f3f3f3] w-full font-poppins min-h-full flex flex-col overflow-x-hidden">
      {!isHide && (
        <div className="flex items-center gap-4 px-4 md:px-7 pt-6 md:pt-8 shrink-0 ">
          <h1 className="font-semibold text-base text-black whitespace-nowrap">
            {pageTitle}
          </h1>
          <hr className="flex-1 border-t-[0.5px] border-[#D4D4D4]" />
          {actionButton && (
            <div className="flex items-center gap-3 shrink-0">
              {actionButton}
            </div>
          )}
        </div>
      )}

      <div className=" flex-1 min-w-0">{children}</div>
    </div>
  );
};

export default PageLayout;
